<modal-layout-right [modalTitle]="'Dimensions & Details'|translate">
    <div modalBody>
        @if(content.product.data?.media | findMediaByLabel : 'dimensions') {
        <div class="w-12 ratio-1-1">
            <img class="rf"
                 [image]="content.product.data.media | findMediaByLabel : 'dimensions'">
        </div>
        }
        <product-view-dimensions-and-details [product]="content.product"
                                             [rightView]="!app.client.isS"
                                             [icons]="content.content.dimensions_icons"
                                             [topAttributes]="content.content.dimensionsTopAttributes"
                                             [sections]="content.content.dimensions_sections">
        </product-view-dimensions-and-details>
    </div>
</modal-layout-right>
